import styled from '@emotion/styled';
import { Row, Col } from 'antd';
import { Badge } from 'antd5';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import MoreHoriz from '@material-ui/icons/MoreHoriz';

import { LAYOUT_CONFIG } from '../../../constants';
import { Input } from '../../forms/';
import theme from '../../../theme';

const { MAX_PAGE_CONTENT_WIDTH } = LAYOUT_CONFIG;

export const DefaultDownIcon = styled(DownOutlined)`
  font-size: 16px;
`;

export const DefaultSearchIcon = styled(SearchOutlined)`
  font-size: 16px;
`;

export const DefaultEllipsisIcon = styled(MoreHoriz)`
  font-size: 24px;
  color: ${theme.colorsSecondaryBlue};
`;

export const ImageContainer = styled.img`
  height: 150px;
  width: 150px;
  object-fit: cover;
`;
// Old Ant-Design Row styles
export const BlockRow = styled(Row)`
  position: relative;
  height: auto;
  margin-right: 0;
  margin-left: 0;
  zoom: 1;
  display: block !important;
  box-sizing: border-box;
`;

export const StyledRowForPanel = styled(Row)`
  padding-top: 20px;
`;
export const StyledBlockRowForPanel = styled(BlockRow)`
  padding-top: 20px;
`;
export const StyledColForPanel = styled(Col)`
  padding-right: 20px;
`;
export const StyledRowForRadioSub = styled(Row)`
  padding: 10px 0;
`;
export const StyledColForRadioSub = styled(Col)`
  padding-left: 30px;
  padding-right: 10px;
`;
export const StyledTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const DescriptionContainer = styled.div`
  margin-top: 20px;
`;

export const DescriptionTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 30px;
`;

export const SectionContainer = styled.div``;

export const SectionText = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const DefaultButtonBlock = styled.div`
  display: inline-block;
  margin-top: 20px;
`;

export const ButtonGroup = styled.div`
  margin-top: 30px;
`;

export const ButtonInline = styled.div`
  display: inline-block;
  margin-right: 30px;
  margin-top: 10px;
`;

export const ShowItem = styled.div`
  margin-top: 10px;
  margin-right: 10px;
`;

export const NormalInput = styled(Input)`
  display: block;
  height: 44px;
  width: 100%;
`;

export const PageContainer = styled(Row)`
  min-height: 100vh;
  margin: 0 auto;
  background-color: ${theme.colorsLightestGrey};
  width: 100%;
  max-width: ${MAX_PAGE_CONTENT_WIDTH}px;
  padding: 20px 20px;
  margin: auto;
`;

export const ReviewDescriptionBlock = styled.div`
  white-space: pre-wrap;
  font-size: 14px;
`;

export const InstructionLabel = styled.div`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  color: ${theme.colorsBlack};
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const StyledBadge = styled(Badge)`
  .ant-badge-count {
    background-color: ${theme.colorsSuccessState};
    width: 20px;
    height: 20px;
    min-width: 5px;
    padding: 0 3px;
    font-size: 10px;
  }
`;
